import { PermissionUtils } from '@shared/utils';
import { DashboardCurrencies } from './dashboardCurrencies';
import { DashboardSpendingCurrency } from './dashboardSpendingCurrency';
import { DashboardExpenseCategories } from './dashboardExpenseCategories';
import { DashboardMerchants } from './dashboardMerchants';

export const CardTab = () => {
  return (
    <>
      {PermissionUtils.viewCurrenciesSummary() && <DashboardCurrencies />}
      {PermissionUtils.viewSpendingByCurrency() && <DashboardSpendingCurrency />}
      {PermissionUtils.viewExpenseCategories() && <DashboardExpenseCategories />}
      {PermissionUtils.viewMostUsedMerchants() && <DashboardMerchants />}
    </>
  );
};
